(function () {
  var base = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MONTHS = ['ene', 'feb', 'mar', 'abr', 'may', 'jun', 'jul', 'ago', 'sep', 'oct', 'nov', 'dic'];

  function money(cents) { return '$' + Math.round(cents / 100).toLocaleString('es-AR'); }
  function unitsOf(title) { var n = parseInt(String(title || '').split(' ')[0], 10); return isNaN(n) || n < 1 ? 1 : n; }
  function addBusinessDays(d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; } return r; }
  function fmtDate(d) { return d.getDate() + ' ' + MONTHS[d.getMonth()]; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function postJSON(url, body) {
    return fetch(base + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { if (!r.ok) throw new Error(url); return r.json(); });
  }
  function syncHeaderBubble(count) {
    document.querySelectorAll('cart-icon').forEach(function (el) {
      if (typeof el.renderCartBubble === 'function') { try { el.renderCartBubble(count, false); } catch (e) {} }
    });
  }

  document.querySelectorAll('.sx').forEach(function (root) {
    var cartEl = root.querySelector('[data-sn-cart]');
    var unitPrice = parseInt(root.dataset.unitPrice || '0', 10);
    var freeFrom = parseInt(root.dataset.freeFrom || '2', 10);
    var productId = String(root.dataset.productId || '');

    // Packs available on the page: [{ id, units, cents }]
    var packs = [];
    root.querySelectorAll('input[data-sx-variant]').forEach(function (i) {
      var u = parseInt(i.dataset.units, 10), c = parseInt(i.dataset.cents, 10);
      if (u > 0 && c > 0 && i.dataset.available === 'true') packs.push({ id: Number(i.value), units: u, cents: c });
    });

    /* ---------- Pack selector ---------- */
    var btn = root.querySelector('[data-sx-buy]');
    if (btn) {
      var priceEl = root.querySelector('[data-sx-price]');
      var labelEl = root.querySelector('[data-sx-label]');
      var errorEl = root.querySelector('[data-sx-error]');
      root.querySelectorAll('input[data-sx-variant]').forEach(function (input) {
        input.addEventListener('change', function () {
          var ok = input.dataset.available === 'true';
          btn.dataset.variant = input.value;
          priceEl.textContent = input.dataset.price;
          labelEl.textContent = ok ? 'Agregar al carrito' : 'Sin stock';
          btn.disabled = !ok;
          errorEl.hidden = true;
        });
      });
      btn.addEventListener('click', function () {
        btn.classList.add('is-loading');
        errorEl.hidden = true;
        postJSON('cart/add.js', { items: [{ id: Number(btn.dataset.variant), quantity: 1 }] }).then(function () {
          btn.classList.remove('is-loading');
          if (cartEl) { openCart(); } else { window.location.href = base + 'checkout'; }
        }).catch(function () {
          btn.classList.remove('is-loading');
          errorEl.hidden = false;
        });
      });
    }

    /* ---------- Sticky buy bar (mobile) ---------- */
    var sticky = root.querySelector('[data-sn-sticky]');
    if (sticky) {
      var sPortal = document.createElement('div');
      sPortal.className = 'sx sn-portal';
      document.body.appendChild(sPortal);
      sPortal.appendChild(sticky);
      var heroEl = root.querySelector('.sn-hero'), buyEl = root.querySelector('#comprar'), vis = {};
      if ('IntersectionObserver' in window && heroEl && buyEl) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) { vis[e.target === heroEl ? 'h' : 'b'] = e.isIntersecting; });
          sticky.classList.toggle('is-on', !vis.h && !vis.b);
        });
        io.observe(heroEl); io.observe(buyEl);
      }
    }

    if (!cartEl) return;

    // Move the drawer to <body> so "position: fixed" is relative to the screen, not the section
    var portal = document.createElement('div');
    portal.className = 'sx sn-portal';
    document.body.appendChild(portal);
    portal.appendChild(cartEl);

    /* ---------- Side cart ---------- */
    var itemsEl = cartEl.querySelector('[data-sn-items]');
    var q = function (sel) { return cartEl.querySelector(sel); };
    var optimal = null;

    // Cheapest combination of packs for a number of units (small DP)
    function bestCombo(units) {
      if (!packs.length || units < 1 || units > 60) return null;
      var cost = [0], pick = [null];
      for (var u = 1; u <= units; u++) {
        cost[u] = Infinity; pick[u] = null;
        packs.forEach(function (p) {
          if (p.units <= u && cost[u - p.units] + p.cents < cost[u]) { cost[u] = cost[u - p.units] + p.cents; pick[u] = p; }
        });
      }
      if (!isFinite(cost[units])) return null;
      var items = {}, u2 = units;
      while (u2 > 0) { var p = pick[u2]; items[p.id] = (items[p.id] || 0) + 1; u2 -= p.units; }
      return { cents: cost[units], items: items };
    }

    function render(cart) {
      var units = 0, saving = 0, ourTotal = 0, ourKeys = [], html = '';
      cart.items.forEach(function (it) {
        var isOurs = String(it.product_id) === productId;
        var u = isOurs ? unitsOf(it.variant_title) : 0;
        units += u * it.quantity;
        if (isOurs) { ourTotal += it.final_line_price; ourKeys.push(it.key); }
        var full = isOurs ? unitPrice * u * it.quantity : 0;
        var lineSave = isOurs ? Math.max(0, full - it.final_line_price) : 0;
        saving += lineSave;
        html += '<div class="sn-ci" data-key="' + esc(it.key) + '">' +
          (it.image ? '<img class="sn-ci__img" src="' + esc(it.image) + '" alt="" width="72" height="72" loading="lazy">' : '<span class="sn-ci__img"></span>') +
          '<div class="sn-ci__info"><p class="sn-ci__title">' + esc(it.product_title) + '</p>' +
          (it.variant_title ? '<p class="sn-ci__variant">' + esc(it.variant_title) + '</p>' : '') +
          (lineSave > 0 ? '<span class="sn-ci__save">Ahorrás ' + money(lineSave) + '</span>' : '') +
          '</div><div class="sn-ci__side"><p class="sn-ci__price">' + money(it.final_line_price) + '</p>' +
          (lineSave > 0 ? '<s class="sn-ci__full">' + money(full) + '</s>' : '') +
          '<div class="sn-ci__qty"><button type="button" data-sn-qty="-1" aria-label="Restar">−</button><span>' + it.quantity + '</span><button type="button" data-sn-qty="1" aria-label="Sumar">+</button></div></div></div>';
      });
      if (!cart.items.length) html = '<p class="sn-cart__empty">Tu carrito está vacío.</p>';
      itemsEl.innerHTML = html;

      // Suggest switching to packs when it is cheaper
      optimal = null;
      var combo = bestCombo(units);
      var upsell = q('[data-sn-upsell]');
      if (combo && combo.cents < ourTotal - 50) {
        optimal = { combo: combo, keys: ourKeys };
        q('[data-sn-upsell-msg]').innerHTML = 'Te conviene armarlo en packs: pagás <b>' + money(combo.cents) + '</b> en vez de ' + money(ourTotal) + ' y <b>ahorrás ' + money(ourTotal - combo.cents) + '</b>.';
        q('[data-sn-optimize]').disabled = false;
        upsell.hidden = false;
      } else {
        upsell.hidden = true;
      }

      q('[data-sn-count]').textContent = cart.item_count;
      var pct = Math.min(1, units / freeFrom);
      q('[data-sn-bar]').style.width = (pct * 100) + '%';
      cartEl.classList.toggle('is-free', units >= freeFrom);
      var missing = freeFrom - units;
      q('[data-sn-ship-msg]').innerHTML = units >= freeFrom
        ? '<b>¡Tenés envío gratis!</b>'
        : (units === 0 ? 'Llevando ' + freeFrom + ' frascos el envío es <b>gratis</b>' : 'Sumá <b>' + missing + ' frasco' + (missing > 1 ? 's' : '') + '</b> más y el envío es gratis');
      q('[data-sn-save-row]').hidden = saving <= 0;
      q('[data-sn-save]').textContent = '−' + money(saving);
      q('[data-sn-total]').textContent = money(cart.total_price);
      q('[data-sn-pay]').textContent = money(cart.total_price);
      q('.sn-cart__pay').classList.toggle('is-disabled', !cart.items.length);

      var now = new Date();
      q('[data-sn-d0]').textContent = fmtDate(now);
      q('[data-sn-d1]').textContent = fmtDate(addBusinessDays(now, 1));
      q('[data-sn-d2]').textContent = fmtDate(addBusinessDays(now, 3)) + '–' + fmtDate(addBusinessDays(now, 6));

      syncHeaderBubble(cart.item_count);
    }

    function refresh() {
      return fetch(base + 'cart.js', { headers: { 'Accept': 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.json(); }).then(render);
    }

    function openCart() {
      refresh().then(function () {
        cartEl.hidden = false;
        document.documentElement.classList.add('sn-cart-open');
        requestAnimationFrame(function () { cartEl.classList.add('is-open'); });
      });
    }
    function closeCart() {
      cartEl.classList.remove('is-open');
      document.documentElement.classList.remove('sn-cart-open');
      setTimeout(function () { cartEl.hidden = true; }, 350);
    }

    function optimize() {
      if (!optimal) return;
      var b = q('[data-sn-optimize]'); b.disabled = true;
      var updates = {};
      optimal.keys.forEach(function (k) { updates[k] = 0; });
      var items = Object.keys(optimal.combo.items).map(function (id) { return { id: Number(id), quantity: optimal.combo.items[id] }; });
      postJSON('cart/update.js', { updates: updates })
        .then(function () { return postJSON('cart/add.js', { items: items }); })
        .then(refresh)
        .catch(refresh);
    }

    cartEl.addEventListener('click', function (e) {
      if (e.target.closest('[data-sn-close]')) { closeCart(); return; }
      if (e.target.closest('[data-sn-optimize]')) { optimize(); return; }
      var qb = e.target.closest('[data-sn-qty]');
      if (qb) {
        var row = qb.closest('[data-key]');
        var current = parseInt(row.querySelector('.sn-ci__qty span').textContent, 10) || 0;
        var next = Math.max(0, current + parseInt(qb.dataset.snQty, 10));
        row.classList.add('is-loading');
        postJSON('cart/change.js', { id: row.dataset.key, quantity: next }).then(render).catch(refresh);
      }
      if (e.target.closest('.sn-cart__pay.is-disabled')) e.preventDefault();
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && cartEl.classList.contains('is-open')) closeCart(); });

    // Header cart icon opens this drawer (the theme's own drawer doesn't see items added here)
    window.addEventListener('click', function (e) {
      var trigger = e.target.closest && e.target.closest('[aria-controls="cart-drawer"], a.action__cart, header a[href$="/cart"]');
      if (!trigger) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      openCart();
    }, true);
  });
})();
